import axios from 'axios';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import Button from '../../components/UI/Button';
import { IOneShopListData } from './interfaces/shoplist.interface';
import Container from '../../components/UI/Container';
import Grid from '../../components/UI/Grid';
import Select from '../../components/UI/Select';
import Radio from '../../components/UI/Radio';
import Box from '../../components/UI/Box';
import TextField from '../../components/UI/TextField';
import CheckBox from '../../components/UI/CheckBox';
import Accordion from '../../components/UI/Accordion';
import { axiosCustom } from '../../function/common';
import Tooltip from '../../components/UI/Tooltip';
import Text from '../../components/UI/Text';
import DatePicker from '../../components/UI/DatePicker';

interface IShopListUpdateProps {
    empShopCode: string;
    gmpShopCode: string;
    globalShopCode: string;
}

const cateRadioData = [
    { name: '오픈마켓/소셜/임대형', value: '1' },
    {
        name: '종합몰/백화점몰',
        value: '2',
    },
    {
        name: '전문몰',
        value: '3',
    },
    {
        name: '해외쇼핑몰',
        value: '4',
    },
];

const versionsCheckBoxData = [
    {
        name: 'DESK',
        value: 'desk',
    },
    {
        name: 'LIGHT',
        value: 'light',
    },
    {
        name: 'PRO',
        value: 'pro',
    },
    {
        name: 'PREMIUM',
        value: 'premium',
    },
];

const supportRadioData = [
    {
        name: '플토닷컴 노출 안함',
        value: '0',
    },
    { name: '플토닷컴 노출', value: '1' },
];

const excelSupportRadioData = [
    {
        name: '엑셀 노출 안함',
        value: '0',
    },
    { name: '엑셀 노출 함', value: '1' },
];

export default function ShopListUpdate() {
    // state가 존재한다는건 solType, shopCode가 존재한다는거다. 그러면 수정작업임
    const state = useLocation().state as IShopListUpdateProps;
    const [name, setName] = React.useState('');
    const [keyword, setKeyWord] = React.useState('');
    const [ready, setReady] = React.useState(false);
    const [update, setUpdate] = React.useState(false);
    const [empOpenDateYN, setempOpenDateYN] = React.useState('');
    const [gmpOpenDateYN, setgmpOpenDateYN] = React.useState('');
    const [globalOpenDateYN, setglobalOpenDateYN] = React.useState('');
    const [shopListData, setShopListData] = React.useState<IOneShopListData>({
        //기본정보
        solType: 'EMP',
        id: 0,
        sorting: 0,
        shopName: '',
        keyword: '',
        cate: '1',
        support: '0',
        excelSupport: '0',
        img: '',

        empShopCode: '',
        empOpenDate: '',
        empRenewalDate: '',

        gmpShopCode: '',
        gmpOpenDate: '',
        gmpRenewalDate: '',

        globalShopCode: '',
        globalOpenDate: '',
        globalRenewalDate: '',

        //EMP 기타정보
        empVersions: [] as string[],
        empNew: '0',
        empRegist: '0',
        empContentAddMethod:
            'EMP 환경설정 > 사이트/ID관리 Tab 클릭 > [추가] 버튼 클릭 > 쇼핑몰 선택 후 쇼핑몰 계정정보 입력 > 저장',
        empMemo: '',
        empContentIssue1: '',
        empContentIssue2: '',
        empContentIssue3: '',
        empContentNavi: '',

        //EMP 상품정보
        empRegistProd: '0',
        empEditProdAll: '0',
        empStopProd: '0',
        empSyncProdState: '0',
        empScrapProd: '0',

        //EMP 주문정보
        empConfirmOrder: '0',
        empScrapOrder: '0',
        empSendDelivNo: '0',
        empPartialShipment: '0',
        empSyncOrderState: '0',

        //EMP 문의정보
        empScrapCs: '0',
        empScrapEmergencyCs: '0',
        empScrapReview: '0',
        empSendCs: '0',
        empSendEmergencyCs: '0',
        empSendReview: '0',

        // GMP 상품정보
        gmpRegistProd: '0',
        gmpEditProdAll: '0',
        gmpStopProd: '0',
        gmpScrapProd: '0',

        // GMP 상품 부분수정
        gmpEditProdName: '0',
        gmpEditProdPrice: '0',
        gmpEditProdOption: '0',
        gmpEditProdAddOption: '0',
        gmpEditProdDetail: '0',
        gmpEditProdImg: '0',

        // GMP 상품 동기화
        gmpSyncProdState: '0',
        gmpSyncProdStateEnd: '0',
        gmpSyncProdStatePrice: '0',
        gmpSyncProdStateStock: '0',

        // GMP 주문정보
        gmpScrapOrderConfirmList: '0',
        gmpScrapOrder: '0',
        gmpDelayedOrderDo: '0',
        gmpConfirmOrder: '0',
        gmpConfirmOrderAuto: '0',
        gmpSendDelivNo: '0',
        gmpPartialShipment: '0',
        gmpSyncOrderState: '0',

        // GMP 문의 및 정산정보
        gmpScrapCs: '0',
        gmpScrapEmergencyCs: '0',
        gmpScrapPayBack: '0',
        gmpScrapReview: '0',
        gmpSendCs: '0',
        gmpSendEmergencyCs: '0',
        gmpSendReview: '0',

        // GLOBAL 상품정보
        globalRegistProd: '0',
        globalEditProdAll: '0',
        globalEndProd: '0',
        globalScrapProd: '0',

        // GLOBAL 상품 동기화
        globalSyncProdState: '0',
        globalSyncProdStateEnd: '0',
        globalSyncProdStatePrice: '0',
        globalSyncProdStateStock: '0',

        // GLOBAL 주문정보
        globalScrapOrder: '0',
        globalSendDelivNo: '0',
        globalPartialShipment: '0',
        globalSyncOrderState: '0',

        // GLOBAL 문의정보
        globalScrapCs: '0',
        globalSendCs: '0',
    });

    React.useEffect(() => {
        ip();
    }, []);

    // IP 검사
    async function ip() {
        try {
            await axiosCustom.get(`${process.env.REACT_APP_BACKEND_ENDPOINT}/restApi/plto/ip-check`);
        } catch (error: any) {
            const confirm = await Swal.fire({
                title: '실패',
                html: error.message,
                icon: 'error',
            });
            if (confirm.isConfirmed) {
                window.location.href = 'https://plto.com';
            }
        }
    }

    const supportFunctionList: {
        [key in IOneShopListData['solType']]: {
            CS: (keyof IOneShopListData)[];
            ORDER: (keyof IOneShopListData)[];
            PROD1: (keyof IOneShopListData)[];
            PROD2: (keyof IOneShopListData)[];
            PROD3: (keyof IOneShopListData)[];
        };
    } = {
        EMP: {
            CS: [
                'empScrapCs',
                'empSendCs',
                'empScrapEmergencyCs',
                'empSendEmergencyCs',
                'empScrapReview',
                'empSendReview',
            ],
            ORDER: ['empConfirmOrder', 'empScrapOrder', 'empSendDelivNo', 'empPartialShipment', 'empSyncOrderState'],
            PROD1: ['empScrapProd', 'empRegistProd', 'empEditProdAll', 'empStopProd', 'empSyncProdState'],
            PROD2: [],
            PROD3: [],
        },
        GMP: {
            CS: [
                'gmpScrapCs',
                'gmpSendCs',
                'gmpScrapEmergencyCs',
                'gmpSendEmergencyCs',
                'gmpScrapReview',
                'gmpSendReview',
                'gmpScrapPayBack',
            ],
            ORDER: [
                'gmpScrapOrderConfirmList',
                'gmpScrapOrder',
                'gmpDelayedOrderDo',
                'gmpConfirmOrder',
                'gmpConfirmOrderAuto',
                'gmpSendDelivNo',
                'gmpPartialShipment',
                'gmpSyncOrderState',
            ],
            PROD1: ['gmpRegistProd', 'gmpEditProdAll', 'gmpStopProd', 'gmpScrapProd'],
            PROD2: [
                'gmpEditProdName',
                'gmpEditProdPrice',
                'gmpEditProdOption',
                'gmpEditProdAddOption',
                'gmpEditProdDetail',
                'gmpEditProdImg',
            ],
            PROD3: ['gmpSyncProdState', 'gmpSyncProdStateEnd', 'gmpSyncProdStatePrice', 'gmpSyncProdStateStock'],
        },
        GLOBAL: {
            CS: ['globalScrapCs', 'globalSendCs'],
            ORDER: ['globalScrapOrder', 'globalSendDelivNo', 'globalPartialShipment', 'globalSyncOrderState'],
            PROD1: ['globalRegistProd', 'globalEditProdAll', 'globalEndProd', 'globalScrapProd'],
            PROD2: [
                'globalSyncProdState',
                'globalSyncProdStateEnd',
                'globalSyncProdStatePrice',
                'globalSyncProdStateStock',
            ],
            PROD3: [],
        },
    };

    const cateOnChange = (e: any) => {
        setShopListData({ ...shopListData, cate: e.target.value });
    };
    const supportOnChange = (e: any) => {
        setShopListData({ ...shopListData, support: e.target.value });
    };
    const excelSupportOnChange = (e: any) => {
        setShopListData({ ...shopListData, excelSupport: e.target.value });
    };
    const empShopCodeOnChange = (e: any) => {
        setShopListData({ ...shopListData, empShopCode: e.target.value });
    };
    const gmpShopCodeOnChange = (e: any) => {
        setShopListData({ ...shopListData, gmpShopCode: e.target.value });
    };
    const globalShopCodeOnChange = (e: any) => {
        setShopListData({ ...shopListData, globalShopCode: e.target.value });
    };
    const shopNameOnChange = (e: any) => {
        setShopListData({ ...shopListData, shopName: e.target.value });
    };
    const keywordOnChange = (e: any) => {
        setShopListData({ ...shopListData, keyword: e.target.value });
    };
    const imgOnChange = (e: any) => {
        setShopListData({ ...shopListData, img: e.target.value });
    };

    //Text Area
    const empContentAddMethodOnChange = (e: any) => {
        setShopListData({ ...shopListData, empContentAddMethod: e.target.value });
    };

    const empContentIssue1OnChange = (e: any) => {
        setShopListData({ ...shopListData, empContentIssue1: e.target.value });
    };

    const empContentIssue2OnChange = (e: any) => {
        setShopListData({ ...shopListData, empContentIssue2: e.target.value });
    };

    const empContentIssue3OnChange = (e: any) => {
        setShopListData({ ...shopListData, empContentIssue3: e.target.value });
    };

    const empMemoOnChange = (e: any) => {
        setShopListData({ ...shopListData, empMemo: e.target.value });
    };

    const empContentNaviOnChange = (e: any) => {
        setShopListData({ ...shopListData, empContentNavi: e.target.value });
    };

    const empVersionOnChange = (e: any) => {
        if (e.currentTarget.checked) {
            setShopListData({ ...shopListData, empVersions: [...shopListData.empVersions, e.target.value] });
        } else {
            setShopListData({
                ...shopListData,
                empVersions: [
                    ...shopListData.empVersions.filter(function (item: any) {
                        return item !== e.target.value;
                    }),
                ],
            });
        }
    };

    const openDateOnChange = (e: any, eventReturnValue: any) => {
        setShopListData({ ...shopListData, [eventReturnValue]: e });
    };

    const empOpenDateRadioOnChange = (e: any) => {
        setempOpenDateYN(e.target.value);
    };

    const gmpOpenDateRadioOnChange = (e: any) => {
        setgmpOpenDateYN(e.target.value);
    };

    const globalOpenDateRadioOnChange = (e: any) => {
        setglobalOpenDateYN(e.target.value);
    };

    async function getOneJobData() {
        Swal.fire({
            title: '잠시만 기다려 주세요.',
            html: '작업 조회중 ...', // add html attribute if you want or remove
            allowOutsideClick: false,
            showConfirmButton: false,
            willOpen: () => {
                Swal.showLoading();
            },
        });
        try {
            const { data: result } = await axios.get(
                //`${process.env.REACT_APP_BACKEND_ENDPOINT}/restApi/plto/get-shop-list`,
                `${process.env.REACT_APP_BACKEND_ENDPOINT}/restApi/plto/get-one-shop-list`,
                {
                    params: {
                        empShopCode: state.empShopCode,
                        gmpShopCode: state.gmpShopCode,
                        globalShopCode: state.globalShopCode,
                    },
                },
            );
            if (!result.success) {
                Swal.fire({
                    title: '실패',
                    html: `정보가 조회되지 않습니다.`,
                    icon: 'error',
                });
            } else {
                setShopListData(result.result);
                setName(`${result.result.shopName}`);
                setKeyWord(`${result.result.keyword}`);
                setReady(true);
                setUpdate(true);

                setempOpenDateYN(result.result.empOpenDate ? '1' : '0');
                setgmpOpenDateYN(result.result.gmpOpenDate ? '1' : '0');
                setglobalOpenDateYN(result.result.globalOpenDate ? '1' : '0');

                Swal.close();
            }
        } catch (error: any) {
            Swal.fire({
                title: '실패',
                html: `${error.message}`,
                icon: 'error',
            });
        }
    }
    React.useEffect(() => {
        if (state !== undefined) {
            getOneJobData();
        } else {
            setReady(true);
        }
    }, []);

    const saveOnClick = async () => {
        if (
            shopListData.support !== '1' &&
            shopListData.empShopCode === '' &&
            shopListData.gmpShopCode === '' &&
            shopListData.globalShopCode === ''
        ) {
            Swal.fire({ title: '유효성 검사 실패', html: '쇼핑몰 코드는 필수입니다.', icon: 'error' });
            return false;
        }
        if (shopListData.shopName === '') {
            Swal.fire({ title: '유효성 검사 실패', html: '쇼핑몰 명은 필수입니다.', icon: 'error' });
            return false;
        }
        let alertMessage = '';
        if (shopListData.support === '0') {
            alertMessage += '플토닷컴 노출 X<br>';
        }
        if (shopListData.support === '1') {
            alertMessage += '플토닷컴 노출 O<br>';
        }
        if (shopListData.excelSupport === '0') {
            alertMessage += '플토닷컴 엑셀 노출 X<br>';
        }
        if (shopListData.excelSupport === '1') {
            alertMessage += '플토닷컴 엑셀 노출 O<br>';
        }
        const agreeSwal = await Swal.fire({
            title: '플토 닷컴 노출 여부 확인',
            html: `${alertMessage}으로 설정하시겠습니까?`,
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: '취소',
            confirmButtonText: '확인',
        });
        // 동의하지 않았을 때
        if (!agreeSwal.isConfirmed) {
            return false;
        }
        Swal.fire({
            title: '잠시만 기다려 주세요.',
            html: '작업 조회중 ...',
            allowOutsideClick: false,
            showConfirmButton: false,
            willOpen: () => {
                Swal.showLoading();
            },
        });
        try {
            const { data: result } = await axios.post(
                `${process.env.REACT_APP_BACKEND_ENDPOINT}/restApi/plto/update-shop-list`,
                {
                    // 기본정보
                    id: shopListData.id,
                    shopName: shopListData.shopName,
                    cate: shopListData.cate,
                    support: shopListData.support,
                    excelSupport: shopListData.excelSupport,
                    img: shopListData.img,

                    empShopCode: shopListData.empShopCode,
                    empOpenDate: empOpenDateYN === '0' ? null : shopListData.empOpenDate,
                    empRenewalDate: shopListData.empRenewalDate,

                    gmpShopCode: shopListData.gmpShopCode,
                    gmpOpenDate: gmpOpenDateYN === '0' ? null : shopListData.gmpOpenDate,
                    gmpRenewalDate: shopListData.gmpRenewalDate,

                    globalShopCode: shopListData.globalShopCode,
                    globalOpenDate: globalOpenDateYN === '0' ? null : shopListData.globalOpenDate,
                    globalRenewalDate: shopListData.globalRenewalDate,

                    empRegist: '1',
                    empContentAddMethod: shopListData.empContentAddMethod,
                    empMemo: shopListData.empMemo,
                    empContentIssue1: shopListData.empContentIssue1,
                    empContentIssue2: shopListData.empContentIssue2,
                    empContentIssue3: shopListData.empContentIssue3,
                    empContentNavi: shopListData.empContentNavi,
                    empVersions: shopListData.empVersions.join(','),

                    //EMP 상품정보
                    empRegistProd: shopListData.empRegistProd,
                    empEditProdAll: shopListData.empEditProdAll,
                    empStopProd: shopListData.empStopProd,
                    empSyncProdState: shopListData.empSyncProdState,
                    empScrapProd: shopListData.empScrapProd,

                    //EMP 주문정보
                    empConfirmOrder: shopListData.empConfirmOrder,
                    empScrapOrder: shopListData.empScrapOrder,
                    empSendDelivNo: shopListData.empSendDelivNo,
                    empPartialShipment: shopListData.empPartialShipment,
                    empSyncOrderState: shopListData.empSyncOrderState,

                    //EMP 문의정보
                    empScrapCs: shopListData.empScrapCs,
                    empScrapEmergencyCs: shopListData.empScrapEmergencyCs,
                    empScrapReview: shopListData.empScrapReview,
                    empSendCs: shopListData.empSendCs,
                    empSendEmergencyCs: shopListData.empSendEmergencyCs,
                    empSendReview: shopListData.empSendReview,

                    // GMP 상품정보
                    gmpRegistProd: shopListData.gmpRegistProd,
                    gmpEditProdAll: shopListData.gmpEditProdAll,
                    gmpStopProd: shopListData.gmpStopProd,
                    gmpScrapProd: shopListData.gmpScrapProd,

                    // GMP 상품 부분수정
                    gmpEditProdName: shopListData.gmpEditProdName,
                    gmpEditProdPrice: shopListData.gmpEditProdPrice,
                    gmpEditProdOption: shopListData.gmpEditProdOption,
                    gmpEditProdAddOption: shopListData.gmpEditProdAddOption,
                    gmpEditProdDetail: shopListData.gmpEditProdDetail,
                    gmpEditProdImg: shopListData.gmpEditProdImg,

                    // GMP 상품 동기화
                    gmpSyncProdState: shopListData.gmpSyncProdState,
                    gmpSyncProdStateEnd: shopListData.gmpSyncProdStateEnd,
                    gmpSyncProdStatePrice: shopListData.gmpSyncProdStatePrice,
                    gmpSyncProdStateStock: shopListData.gmpSyncProdStateStock,

                    // GMP 주문정보
                    gmpScrapOrderConfirmList: shopListData.gmpScrapOrderConfirmList,
                    gmpScrapOrder: shopListData.gmpScrapOrder,
                    gmpDelayedOrderDo: shopListData.gmpDelayedOrderDo,
                    gmpConfirmOrder: shopListData.gmpConfirmOrder,
                    gmpConfirmOrderAuto: shopListData.gmpConfirmOrderAuto,
                    gmpSendDelivNo: shopListData.gmpSendDelivNo,
                    gmpPartialShipment: shopListData.gmpPartialShipment,
                    gmpSyncOrderState: shopListData.gmpSyncOrderState,

                    // GMP 문의 및 정산정보
                    gmpScrapCs: shopListData.gmpScrapCs,
                    gmpScrapEmergencyCs: shopListData.gmpScrapEmergencyCs,
                    gmpScrapPayBack: shopListData.gmpScrapPayBack,
                    gmpScrapReview: shopListData.gmpScrapReview,
                    gmpSendCs: shopListData.gmpSendCs,
                    gmpSendEmergencyCs: shopListData.gmpSendEmergencyCs,
                    gmpSendReview: shopListData.gmpSendReview,

                    // GLOBAL 상품정보
                    globalRegistProd: shopListData.globalRegistProd,
                    globalEditProdAll: shopListData.globalEditProdAll,
                    globalEndProd: shopListData.globalEndProd,
                    globalScrapProd: shopListData.globalScrapProd,

                    // GLOBAL 상품 동기화
                    globalSyncProdState: shopListData.globalSyncProdState,
                    globalSyncProdStateEnd: shopListData.globalSyncProdStateEnd,
                    globalSyncProdStatePrice: shopListData.globalSyncProdStatePrice,
                    globalSyncProdStateStock: shopListData.globalSyncProdStateStock,

                    // GLOBAL 주문정보
                    globalScrapOrder: shopListData.globalScrapOrder,
                    globalSendDelivNo: shopListData.globalSendDelivNo,
                    globalPartialShipment: shopListData.globalPartialShipment,
                    globalSyncOrderState: shopListData.globalSyncOrderState,

                    // GLOBAL 문의정보
                    globalScrapCs: shopListData.globalScrapCs,
                    globalSendCs: shopListData.globalSendCs,

                    keyword: shopListData.keyword,
                },
            );

            if (!result.success) {
                Swal.fire({
                    title: '실패',
                    html: update ? `쇼핑몰 정보 수정 실패.` : `쇼핑몰 정보 등록 실패`,
                    icon: 'error',
                });
            } else {
                Swal.fire({
                    title: '성공',
                    html: update ? `쇼핑몰 정보 수정 완료.` : `쇼핑몰 정보 등록 완료`,
                    icon: 'success',
                    preConfirm: () => {
                        update ? console.log() : window.history.back();
                    },
                });
            }
        } catch (error: any) {
            Swal.fire({
                title: '실패',
                html: `${error.message}`,
                icon: 'error',
            });
        }
    };

    if (!ready) {
        return <div>데이터가 조회되지 않습니다.</div>;
    }

    return (
        <Container style={{ paddingBottom: 80 }}>
            <Grid display="flex" alignItems="center" justifyContent="center" bottom={20}>
                <h2>{update ? `${name} 쇼핑몰 수정` : '쇼핑몰 등록'}</h2>
            </Grid>
            <Grid display="flex" alignItems="center" justifyContent="flex-end" bottom={20}>
                <Button type="submit" onClick={saveOnClick}>
                    {update ? '수정' : '등록'}
                </Button>
                &nbsp;
                <Link
                    to={{
                        pathname: '/admin/shop-list',
                    }}
                >
                    {' '}
                    <Button variant="outlined">취소</Button>
                </Link>
            </Grid>

            <Accordion title="기본 정보" expanded={true}>
                <Box label="쇼핑몰 구분 선택">
                    <Radio
                        name="key_cate"
                        onChange={cateOnChange}
                        list={cateRadioData}
                        value={shopListData.cate === '' ? '1' : shopListData.cate}
                    />
                </Box>
                <Box label="EMP 쇼핑몰코드">
                    <TextField
                        type="text"
                        defaultValue={shopListData.empShopCode}
                        defaultSize="full"
                        onChange={empShopCodeOnChange}
                    />
                </Box>
                <Box label="2.0 쇼핑몰코드">
                    <TextField
                        type="text"
                        defaultValue={shopListData.gmpShopCode}
                        defaultSize="full"
                        onChange={gmpShopCodeOnChange}
                    />
                </Box>
                <Box label="GLOBAL 쇼핑몰코드">
                    <TextField
                        type="text"
                        defaultValue={shopListData.globalShopCode}
                        defaultSize="full"
                        onChange={globalShopCodeOnChange}
                    />
                </Box>
                <Box label="쇼핑몰명">
                    <TextField
                        type="text"
                        placeholder="쇼핑몰 이름을 입력해 주세요"
                        defaultValue={shopListData.shopName}
                        defaultSize="full"
                        onChange={shopNameOnChange}
                    />
                </Box>
                <Box label="키워드">
                    <TextField
                        type="text"
                        placeholder="키워드를 입력해 주세요"
                        defaultValue={shopListData.keyword}
                        defaultSize="full"
                        onChange={keywordOnChange}
                    />
                </Box>
                <Box label="쇼핑몰로고URL">
                    <TextField
                        type="text"
                        placeholder="로고 이미지 파일 다운로드가 가능한 URL"
                        defaultValue={shopListData.img}
                        defaultSize="full"
                        onChange={imgOnChange}
                    />
                </Box>

                <Box label="플토닷컴 노출 여부 선택">
                    <Radio
                        name="key_support"
                        onChange={supportOnChange}
                        list={supportRadioData}
                        value={shopListData.support === '' ? '0' : shopListData.support}
                    />
                    <Text>- 노출안함 선택 : 플토닷컴 연동 쇼핑몰 리스트에 노출되지 않습니다.</Text>
                </Box>

                <Box
                    label="플토닷컴 엑셀 노출 여부"

                    // toolTip={true}
                    // toolTipTitle="노출안함 선택시 플토닷컴에서 엑셀 다운로드 받았을때 노출되지 않음"
                >
                    <Radio
                        name="key_excelSupport"
                        onChange={excelSupportOnChange}
                        list={excelSupportRadioData}
                        value={shopListData.excelSupport === '' ? '0' : shopListData.excelSupport}
                    />
                    <Text>- 노출안함 선택 : 플토닷컴에서 엑셀 다운로드 받았을때 노출되지 않습니다.</Text>
                </Box>

                <Box label="EMP 오픈일">
                    <div
                        style={{
                            display: 'flex',
                            margin: '5px 20px 5px 10px',
                        }}
                    >
                        <Radio
                            onChange={empOpenDateRadioOnChange}
                            list={[
                                {
                                    name: '미오픈',
                                    value: '0',
                                },
                                {
                                    name: '오픈',
                                    value: '1',
                                },
                            ]}
                            value={empOpenDateYN}
                            name="key_support"
                        />
                        {empOpenDateYN === '1' && (
                            <DatePicker
                                selected={shopListData.empOpenDate}
                                onChange={openDateOnChange}
                                name="오픈일 : "
                                width="small"
                                eventReturn="empOpenDate"
                            />
                        )}
                    </div>
                </Box>

                <Box label="GMP 오픈일">
                    <div
                        style={{
                            display: 'flex',
                            margin: '5px 20px 5px 10px',
                        }}
                    >
                        <Radio
                            onChange={gmpOpenDateRadioOnChange}
                            list={[
                                {
                                    name: '미오픈',
                                    value: '0',
                                },
                                {
                                    name: '오픈',
                                    value: '1',
                                },
                            ]}
                            value={gmpOpenDateYN}
                            name="key_support"
                        />
                        {gmpOpenDateYN === '1' && (
                            <DatePicker
                                selected={shopListData.gmpOpenDate}
                                onChange={openDateOnChange}
                                name="오픈일 : "
                                width="small"
                                eventReturn="gmpOpenDate"
                            />
                        )}
                    </div>
                </Box>

                <Box label="GLOBAL 오픈일">
                    <div
                        style={{
                            display: 'flex',
                            margin: '5px 20px 5px 10px',
                        }}
                    >
                        <Radio
                            onChange={globalOpenDateRadioOnChange}
                            list={[
                                {
                                    name: '미오픈',
                                    value: '0',
                                },
                                {
                                    name: '오픈',
                                    value: '1',
                                },
                            ]}
                            value={globalOpenDateYN}
                            name="key_support"
                        />
                        {globalOpenDateYN === '1' && (
                            <DatePicker
                                selected={shopListData.globalOpenDate}
                                onChange={openDateOnChange}
                                name="오픈일 : "
                                width="small"
                                eventReturn="globalOpenDate"
                            />
                        )}
                    </div>
                </Box>
            </Accordion>

            <Accordion title="EMP 정보" expanded={false}>
                {/* EMP 상품정보 테이블 */}
                <table className="table-basic">
                    <thead>
                        <tr>
                            <th colSpan={5}>상품관리</th>
                        </tr>
                        <tr>
                            <th rowSpan={2}>상품가져오기</th>
                            <th rowSpan={2}>상품등록</th>
                            <th rowSpan={2}>상품수정</th>
                            <th rowSpan={2}>상품품절</th>
                            <th rowSpan={2}>상품동기화</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            {supportFunctionList.EMP.PROD1.map((one, index) => (
                                <td key={index}>
                                    <Select
                                        value={shopListData[one].toString()}
                                        onChange={(e) => {
                                            setShopListData({ ...shopListData, [one]: e.target.value });
                                        }}
                                        style={{ fontSize: '0.88rem', width: 100 }}
                                        variant="outlined"
                                    >
                                        <option value="0">X</option>
                                        <option value="1">O</option>
                                        <option value="2">지원예정</option>
                                    </Select>
                                </td>
                            ))}
                        </tr>
                    </tbody>
                </table>
                {/* EMP 주문정보 테이블 */}
                <table className="table-basic">
                    <thead>
                        <tr>
                            <th colSpan={5}>주문관리</th>
                        </tr>
                        <tr>
                            <th rowSpan={2}>발주확인</th>
                            <th rowSpan={2}>주문수집</th>
                            <th rowSpan={2}>송장전송</th>
                            <th rowSpan={2}>부분출고</th>
                            <th rowSpan={2}>주문동기화</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            {supportFunctionList.EMP.ORDER.map((one, index) => (
                                <td key={index}>
                                    <Select
                                        value={shopListData[one].toString()}
                                        onChange={(e) => {
                                            setShopListData({ ...shopListData, [one]: e.target.value });
                                        }}
                                        style={{ fontSize: '0.88rem', width: 100 }}
                                        variant="outlined"
                                    >
                                        {one === 'empScrapOrder' ? (
                                            <>
                                                <option value="0">X</option>
                                                <option value="1">O</option>
                                                <option value="2">지원예정</option>
                                                <option value="3">엑셀연동</option>
                                            </>
                                        ) : (
                                            <>
                                                <option value="0">X</option>
                                                <option value="1">O</option>
                                                <option value="2">지원예정</option>
                                            </>
                                        )}
                                    </Select>
                                </td>
                            ))}
                        </tr>
                    </tbody>
                </table>
                {/* EMP 문의정보 테이블 */}
                <table className="table-basic">
                    <thead>
                        <tr>
                            <th colSpan={6}>문의관리</th>
                        </tr>
                        <tr>
                            <th rowSpan={2}>고객문의수집</th>
                            <th rowSpan={2}>답변전송</th>
                            <th rowSpan={2}>긴급메시지수집</th>
                            <th rowSpan={2}>긴급메시지전송</th>
                            <th>상품평수집</th>
                            <th>상품평전송</th>
                        </tr>
                        <tr>
                            <th colSpan={2}>부가기능</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            {supportFunctionList.EMP.CS.map((one, index) => (
                                <td key={index}>
                                    <Select
                                        value={shopListData[one].toString()}
                                        onChange={(e) => {
                                            setShopListData({ ...shopListData, [one]: e.target.value });
                                        }}
                                        style={{ fontSize: '0.88rem', width: 100 }}
                                        variant="outlined"
                                    >
                                        <option value="0">X</option>
                                        <option value="1">O</option>
                                        <option value="2">지원예정</option>
                                    </Select>
                                </td>
                            ))}
                        </tr>
                    </tbody>
                </table>
                &nbsp;
                <Box label="지원버전">
                    <CheckBox
                        checked={shopListData.empVersions}
                        onChange={empVersionOnChange}
                        list={versionsCheckBoxData}
                        name="versions"
                    />
                </Box>
                <Box label="쇼핑몰 추가 방법">
                    <TextField
                        type="text"
                        textArea={true}
                        rows={10}
                        defaultValue={shopListData.empContentAddMethod}
                        defaultSize="full"
                        onChange={empContentAddMethodOnChange}
                    />
                </Box>
                <Box label="이슈사항1">
                    <TextField
                        type="text"
                        textArea={true}
                        rows={7}
                        defaultValue={shopListData.empContentIssue1}
                        defaultSize="full"
                        onChange={empContentIssue1OnChange}
                    />
                </Box>
                <Box label="이슈사항2">
                    <TextField
                        type="text"
                        textArea={true}
                        rows={7}
                        defaultValue={shopListData.empContentIssue2}
                        defaultSize="full"
                        onChange={empContentIssue2OnChange}
                    />
                </Box>
                <Box label="이슈사항3">
                    <TextField
                        type="text"
                        textArea={true}
                        rows={7}
                        defaultValue={shopListData.empContentIssue3}
                        defaultSize="full"
                        onChange={empContentIssue3OnChange}
                    />
                </Box>
                <Box label="안내">
                    <TextField
                        type="text"
                        textArea={true}
                        rows={7}
                        defaultValue={shopListData.empContentNavi}
                        defaultSize="full"
                        onChange={empContentNaviOnChange}
                    />
                </Box>
            </Accordion>

            <Accordion title="2.0 정보" expanded={false}>
                {/* GMP 상품정보 테이블 PROD1 */}
                <table className="table-basic">
                    <thead>
                        <tr>
                            <th colSpan={4}>상품관리</th>
                        </tr>
                        <tr>
                            <th rowSpan={2}>상품등록</th>
                            <th rowSpan={2}>상품수정</th>
                            <th rowSpan={2}>상품품절</th>
                            <th rowSpan={2}>상품가져오기</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            {supportFunctionList.GMP.PROD1.map((one, index) => (
                                <td key={index}>
                                    <Select
                                        value={shopListData[one].toString()}
                                        onChange={(e) => {
                                            setShopListData({ ...shopListData, [one]: e.target.value });
                                        }}
                                        style={{ fontSize: '0.88rem', width: 100 }}
                                        variant="outlined"
                                    >
                                        <option value="0">X</option>
                                        <option value="1">O</option>
                                        <option value="2">지원예정</option>
                                    </Select>
                                </td>
                            ))}
                        </tr>
                    </tbody>
                </table>
                {/* GMP 상품정보 테이블 PROD2 */}
                <table className="table-basic">
                    <thead>
                        <tr>
                            <th colSpan={6}>상품부분수정</th>
                        </tr>
                        <tr>
                            <th rowSpan={2}>상품명</th>
                            <th rowSpan={2}>판매가</th>
                            <th rowSpan={2}>상품옵션</th>
                            <th rowSpan={2}>추가구매옵션</th>
                            <th rowSpan={2}>상세설명</th>
                            <th rowSpan={2}>이미지</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            {supportFunctionList.GMP.PROD2.map((one, index) => (
                                <td key={index}>
                                    <Select
                                        value={shopListData[one].toString()}
                                        onChange={(e) => {
                                            setShopListData({ ...shopListData, [one]: e.target.value });
                                        }}
                                        style={{ fontSize: '0.88rem', width: 100 }}
                                        variant="outlined"
                                    >
                                        <option value="0">X</option>
                                        <option value="1">O</option>
                                        <option value="2">지원예정</option>
                                    </Select>
                                </td>
                            ))}
                        </tr>
                    </tbody>
                </table>
                {/* GMP 상품정보 테이블 PROD3 */}
                <table className="table-basic">
                    <thead>
                        <tr>
                            <th colSpan={4}>상품동기화</th>
                        </tr>
                        <tr>
                            <th rowSpan={2}>상품상태</th>
                            <th rowSpan={2}>종료일</th>
                            <th rowSpan={2}>가격</th>
                            <th rowSpan={2}>수량</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            {supportFunctionList.GMP.PROD3.map((one, index) => (
                                <td key={index}>
                                    <Select
                                        value={shopListData[one].toString()}
                                        onChange={(e) => {
                                            setShopListData({ ...shopListData, [one]: e.target.value });
                                        }}
                                        style={{ fontSize: '0.88rem', width: 100 }}
                                        variant="outlined"
                                    >
                                        <option value="0">X</option>
                                        <option value="1">O</option>
                                        <option value="2">지원예정</option>
                                    </Select>
                                </td>
                            ))}
                        </tr>
                    </tbody>
                </table>
                {/* GMP 주문정보 테이블 */}
                <table className="table-basic">
                    <thead>
                        <tr>
                            <th colSpan={8}>주문관리</th>
                        </tr>
                        <tr>
                            <th rowSpan={2}>수집(결제)</th>
                            <th rowSpan={2}>수집(신규)</th>
                            <th rowSpan={2}>배송지연</th>
                            <th rowSpan={2}>주문확인</th>
                            <th rowSpan={2}>주문확인자동</th>
                            <th rowSpan={2}>운송장전송</th>
                            <th rowSpan={2}>부분출고</th>
                            <th rowSpan={2}>동기화</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            {supportFunctionList.GMP.ORDER.map((one, index) => (
                                <td key={index}>
                                    <Select
                                        value={shopListData[one].toString()}
                                        onChange={(e) => {
                                            setShopListData({ ...shopListData, [one]: e.target.value });
                                        }}
                                        style={{ fontSize: '0.88rem', width: 100 }}
                                        variant="outlined"
                                    >
                                        {one === 'gmpScrapOrder' ? (
                                            <>
                                                <option value="0">X</option>
                                                <option value="1">O</option>
                                                <option value="2">지원예정</option>
                                                <option value="3">엑셀연동</option>
                                            </>
                                        ) : (
                                            <>
                                                <option value="0">X</option>
                                                <option value="1">O</option>
                                                <option value="2">지원예정</option>
                                            </>
                                        )}
                                    </Select>
                                </td>
                            ))}
                        </tr>
                    </tbody>
                </table>
                {/* GMP 문의 및 정산 정보 테이블 */}
                <table className="table-basic">
                    <thead>
                        <tr>
                            <th colSpan={7}>문의 및 정산</th>
                        </tr>
                        <tr>
                            <th rowSpan={2}>문의수집</th>
                            <th rowSpan={2}>문의전송</th>
                            <th rowSpan={2}>긴급메시지수집</th>
                            <th rowSpan={2}>긴급메시지전송</th>
                            <th rowSpan={2}>상품평수집</th>
                            <th rowSpan={2}>상품평전송</th>
                            <th rowSpan={2}>정산수집</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            {supportFunctionList.GMP.CS.map((one, index) => (
                                <td key={index}>
                                    <Select
                                        value={shopListData[one].toString()}
                                        onChange={(e) => {
                                            setShopListData({ ...shopListData, [one]: e.target.value });
                                        }}
                                        style={{ fontSize: '0.88rem', width: 100 }}
                                        variant="outlined"
                                    >
                                        <option value="0">X</option>
                                        <option value="1">O</option>
                                        <option value="2">지원예정</option>
                                    </Select>
                                </td>
                            ))}
                        </tr>
                    </tbody>
                </table>
            </Accordion>

            <Accordion title="GLOBAL 정보" expanded={false}>
                {/* GLOBAL 상품정보 테이블 PROD1 */}
                <table className="table-basic">
                    <thead>
                        <tr>
                            <th colSpan={4}>상품관리</th>
                        </tr>
                        <tr>
                            <th rowSpan={2}>상품등록</th>
                            <th rowSpan={2}>상품수정</th>
                            <th rowSpan={2}>상품종료</th>
                            <th rowSpan={2}>상품가져오기</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            {supportFunctionList.GLOBAL.PROD1.map((one, index) => (
                                <td key={index}>
                                    <Select
                                        value={shopListData[one].toString()}
                                        onChange={(e) => {
                                            setShopListData({ ...shopListData, [one]: e.target.value });
                                        }}
                                        style={{ fontSize: '0.88rem', width: 100 }}
                                        variant="outlined"
                                    >
                                        <option value="0">X</option>
                                        <option value="1">O</option>
                                        <option value="2">지원예정</option>
                                    </Select>
                                </td>
                            ))}
                        </tr>
                    </tbody>
                </table>
                {/* GLOBAL 상품정보 테이블 PROD2 */}
                <table className="table-basic">
                    <thead>
                        <tr>
                            <th colSpan={4}>상품동기화</th>
                        </tr>
                        <tr>
                            <th rowSpan={2}>상태</th>
                            <th rowSpan={2}>종료일</th>
                            <th rowSpan={2}>가격</th>
                            <th rowSpan={2}>수량</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            {supportFunctionList.GLOBAL.PROD2.map((one, index) => (
                                <td key={index}>
                                    <Select
                                        value={shopListData[one].toString()}
                                        onChange={(e) => {
                                            setShopListData({ ...shopListData, [one]: e.target.value });
                                        }}
                                        style={{ fontSize: '0.88rem', width: 100 }}
                                        variant="outlined"
                                    >
                                        <option value="0">X</option>
                                        <option value="1">O</option>
                                        <option value="2">지원예정</option>
                                    </Select>
                                </td>
                            ))}
                        </tr>
                    </tbody>
                </table>
                {/* GLOBAL 주문정보 테이블 */}
                <table className="table-basic">
                    <thead>
                        <tr>
                            <th colSpan={4}>주문관리</th>
                        </tr>
                        <tr>
                            <th rowSpan={2}>수집</th>
                            <th rowSpan={2}>운송장전송</th>
                            <th rowSpan={2}>부분출고</th>
                            <th rowSpan={2}>동기화</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            {supportFunctionList.GLOBAL.ORDER.map((one, index) => (
                                <td key={index}>
                                    <Select
                                        value={shopListData[one].toString()}
                                        onChange={(e) => {
                                            setShopListData({ ...shopListData, [one]: e.target.value });
                                        }}
                                        style={{ fontSize: '0.88rem', width: 100 }}
                                        variant="outlined"
                                    >
                                        {one === 'globalScrapOrder' ? (
                                            <>
                                                <option value="0">X</option>
                                                <option value="1">O</option>
                                                <option value="2">지원예정</option>
                                                <option value="3">엑셀연동</option>
                                            </>
                                        ) : (
                                            <>
                                                <option value="0">X</option>
                                                <option value="1">O</option>
                                                <option value="2">지원예정</option>
                                            </>
                                        )}
                                    </Select>
                                </td>
                            ))}
                        </tr>
                    </tbody>
                </table>
                {/* GLOBAL 문의 정보 테이블 */}
                <table className="table-basic">
                    <thead>
                        <tr>
                            <th colSpan={2}>문의</th>
                        </tr>
                        <tr>
                            <th rowSpan={2}>문의수집</th>
                            <th rowSpan={2}>문의전송</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            {supportFunctionList.GLOBAL.CS.map((one, index) => (
                                <td key={index}>
                                    <Select
                                        value={shopListData[one].toString()}
                                        onChange={(e) => {
                                            setShopListData({ ...shopListData, [one]: e.target.value });
                                        }}
                                        style={{ fontSize: '0.88rem', width: 100 }}
                                        variant="outlined"
                                    >
                                        <option value="0">X</option>
                                        <option value="1">O</option>
                                        <option value="2">지원예정</option>
                                    </Select>
                                </td>
                            ))}
                        </tr>
                    </tbody>
                </table>
            </Accordion>
        </Container>
    );
}
